<template>
  <div class="product-cart slide-holder">
    <div
      class="row"
      :class="{ 'text-left': isEnglish, 'text-right': isArabic }"
    >
      <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12">
        <div class="time-holder" v-if="mainImage">
          <b-img :src="mainImage" class="offer-image w-100" />
          <div class="time-count" v-if="dealType">{{ dealType }}</div>
        </div>
      </div>
      <div
        class="col-xl-6 col-lg-12 col-md-12 col-sm-12 d-flex flex-column align-items-start justify-content-between"
      >
        <div v-if="slider">
          <div class="card-info">
            <h4 class="main-header my-2" v-if="productTitle && dealType">
              <router-link :to="detailsRoute">{{ productTitle }}</router-link>
            </h4>
            <h4 class="main-header my-2" v-else-if="productTitle">
              <router-link :to="{ path: '/details', query: { id: slider.id } }">
                {{ productTitle }}
              </router-link>
            </h4>
            <h5 class="price m-0" v-if="customerPrice">
              {{ customerPrice | fixedCurrency }} {{ currency }}
            </h5>
            <p class="price-after price m-0" v-if="hasDiscount">
              {{ priceBeforeDiscount | fixedCurrency }} {{ currency }}
            </p>
            <div class="start-end">
              <p class="mt-3" v-if="hasPromotion">
                {{ promotionStartDate }} - {{ promotionEndDate }}
              </p>
            </div>
          </div>
        </div>
        <div
          class="row mb-3 align-items-center w-100"
          :class="{ 'flex-column w-100': !addToCart }"
        >
          <div class="col-12 px-1">
            <router-link v-if="slider" :to="detailsRoute">
              <button class="outline-main">{{ $t("profile.details") }}</button>
            </router-link>
          </div>
          <button v-if="isVisitWebsite" class="mx-2 border-main">
            <a :href="slider.conference_register_link" target="_blank">
              <h5 class="p-2 m-0">{{ $t("login.visitWebsite") }}</h5>
            </a>
          </button>
          <div v-else class="col-12 px-1">
            <a v-if="showAddToCart">
              <button class="bg-main text-white" @click="addToCart(slider)">
                {{ $t("items.addToCart") }}
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>

    <button
      v-if="buttonTrue"
      class="border-main main-color br-5 btn btn-block mt-2"
      @click="getOffer(slider)"
    >
      {{ $t("singleProduct.getOffer") }}
    </button>
  </div>
</template>

<script>
import globalAxios from "@/services/global-axios";
import suppliers from "@/services/suppliers";
import Vue from "vue";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

Vue.use(VueSweetalert2);

export default {
  props: {
    slider: { type: Object, required: true },
    dealType: { type: String },
    buttonTrue: { type: Boolean },
    sort: { type: String },
  },

  computed: {
    isEnglish() {
      return this.$i18n.locale === "en";
    },
    isArabic() {
      return this.$i18n.locale === "ar";
    },
    mainImage() {
      return this.slider?.current_main_image_path;
    },
    productTitle() {
      return this.slider?.product?.title;
    },
    productDetails() {
      return this.slider?.product_details_by_type;
    },
    customerPrice() {
      return this.productDetails?.currency_based_customer_price;
    },
    priceBeforeDiscount() {
      return this.productDetails?.currency_based_price_before_discount;
    },
    hasDiscount() {
      return (
        this.priceBeforeDiscount &&
        this.priceBeforeDiscount > this.customerPrice
      );
    },
    promotion() {
      return this.slider?.buy_get_promotion_running_by_type?.promotion;
    },
    hasPromotion() {
      return this.promotion?.start_date && this.promotion?.end_date;
    },
    promotionStartDate() {
      return this.promotion?.start_date;
    },
    promotionEndDate() {
      return this.promotion?.end_date;
    },
    isVisitWebsite() {
      return this.productDetails?.add_type === "visit_website";
    },
    showAddToCart() {
      return (
        this.addToCart &&
        (this.productDetails?.add_type === "cart" ||
          this.productDetails?.add_type === "both")
      );
    },
    detailsRoute() {
      return {
        path: "/details",
        query: { id: this.slider.id, type: this.dealType },
      };
    },
  },

  data() {
    return {
      cartCounter: 1,
      requestData: { name: null, request_qty: null, comment: null },
      errors: [],
      supplierProductId: null,
    };
  },

  methods: {
    addToCart(myProduct) {
      const data = this.prepareCartData(myProduct);
      return globalAxios
        .post(`cart/add`, data)
        .then((res) => {
          if (res.status === 200) {
            this.sucessMsg(res.data.message);
            this.showCartModal(myProduct);
          }
        })
        .catch((error) => {
          const err = Object.values(error)[2].data;
          this.errors = err.items;
          this.errMsg(err.message);
        })
        .finally(() => {
          setTimeout(() => this.$store.dispatch("cart/getCartProducts"), 500);
        });
    },

    prepareCartData(myProduct) {
      const baseData = {
        product_supplier_id: this.productDetails?.product_supplier_id,
        quantity: this.selected > 0 ? this.selected : 1,
      };

      if (this.sort === "buyXgetY") {
        return {
          ...baseData,
          quantity:
            myProduct.buy_get_promotion_running_by_type.promotion.buy_x || 1,
          buy_get_promotion_id:
            myProduct.buy_get_promotion_running_by_type?.buy_get_promotion_id,
        };
      } else if (this.sort === "buXGetGift") {
        return {
          ...baseData,
          quantity: myProduct.buy_gift_promotions_running_by_type?.buy_x || 1,
          buy_product_supplier_id:
            myProduct.buy_gift_promotions_running_by_type
              ?.buy_product_supplier_id,
        };
      }
      return baseData;
    },

    showCartModal(product) {
      this.$modal.show(
        () => import("@/components/cart/cartModal.vue"),
        { product },
        { width: "700", height: "auto", adaptive: true }
      );
    },

    requestQuotation() {
      const payload = {
        qoute_name: this.requestData.name,
        product_supplier_id: this.supplierProductId,
        request_qty: this.requestData.request_qty,
        comment: this.requestData.comment,
      };
      suppliers
        .requestQuotation(payload)
        .then((resp) => {
          this.errors = {};
          this.sucessMsg(resp.data.message);
          setTimeout(() => {
            document.querySelector(".close").click();
            this.requestData = [];
          }, 500);
          setTimeout(() => {
            this.$router.push({
              name: "QuotationDetails",
              params: { id: resp.data.items.client_quote_id },
            });
          }, 1000);
        })
        .catch((error) => {
          const err = Object.values(error)[2].data;
          this.errors = err.items;
          this.errMsg(err.message);
        });
    },

    storeProductSupplierId(product_supplier_id) {
      this.supplierProductId = product_supplier_id;
    },

    loginFirst() {
      Vue.swal({
        title: this.$t("singleProduct.loginFirst"),
        text: this.$t("singleProduct.registerNow"),
        icon: "warning",
        dangerMode: true,
      }).then(() => {
        this.$router.push("/user-register");
      });
    },

    getOffer() {
      this.$router.push(this.detailsRoute, () => {
        this.$router.go(0);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.product-cart {
  padding: 0;
  margin: 0 10px;
  text-align: center;
  display: inline-block;
  position: relative;
  overflow: hidden;
  min-width: 250px;
  overflow: hidden;
  a {
    display: inline-block;
    opacity: 1;

    border-radius: 50%;
    width: 95%;
    @media (max-width: 992px) {
      width: 100%;
    }
    &:hover {
      opacity: 0.5;
    }
    img {
      min-width: 250px;
      height: 150px;
      border-radius: 0%;
      display: block;
      object-fit: cover;
    }
    button {
      width: 100%;
      margin: 5px 0;
    }
  }
  .card-info {
    margin: auto;
    margin-bottom: 10px;
    text-align: start;
    min-height: 100px;
    h4 {
      a {
        opacity: 1;
        color: #312620;
        font-size: 18px;
        &:hover {
          color: #2b96cc;
        }
      }
    }
  }
  .null-img-holder {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    display: block;
  }
}
.product-silder button:not(:disabled) {
  display: block !important;
}
button.new {
  background: $main-color;
}
.rfqBtn {
  background: #000;
}

.offer-image {
  width: 100%;
  height: 250px;
  object-fit: cover;
  border-radius: 10px;
}

.slide-holder {
  background-color: #eff0f0;
  border-radius: 10px;
  padding: 15px;
  width: 95% !important;
}
@media (max-width: 992px) {
  .slide-holder {
    width: 100% !important;
  }
}

button {
  border-radius: 8px;
  padding: 10px 20px;
  border: none;
  box-shadow: none;
  outline: none;
}

.outline-main {
  border: 2px solid $main-color;
  background: transparent;
  color: $main-color;
}

.supplier-name {
  text-decoration: underline !important;
  color: inherit;
}

.time-holder {
  position: relative;
  text-align: center;
  padding: 0 5px;
}

.time-count {
  position: absolute;
  top: 0;
  left: 10px;
  font-size: 14px;
  background: $main-color;
  border-radius: 0 0 20px 20px;
  color: #fff;
  right: 10px;
  padding: 0 5px;
}

.row {
  @media (max-width: 1200px) {
    justify-content: center !important;
    align-items: center !important;
    text-align: center !important;
  }
}
</style>
